import { useCallback } from 'react';
import { OrderInputRental } from '../../../../clients/quipli-service/order/order-calculation';
import { useAPI } from '../../../../clients/quipli-service/quipli-service-client';
import { toast } from '../../../../util/toasts';
import { ProductItemDataReturn } from './use-product-item-data';

export interface ProductItemUnitsReturn {
  updateUnits: (units: number[]) => void;
}

export const useProductItemUnits = ({
  isNewProduct,
  id,
  orderId,
  updateInputItem,
  refresh,
}: {
  isNewProduct: boolean;
  id?: string;
  orderId: number;
  updateInputItem: ProductItemDataReturn['updateInputItem'];
  refresh?: () => Promise<void>;
}): ProductItemUnitsReturn => {
  const { assignUnits } = useAPI();

  const updateUnits = useCallback(
    (units: number[]) => {
      if (isNewProduct) {
        if (!updateInputItem) {
          console.error('Missing inputItem or onChange for new product unit assignment');
          return;
        }
        updateInputItem({ assignedUnits: units } as OrderInputRental);
      } else {
        const orderProductId = parseInt(id || '0');
        if (!orderProductId || isNaN(orderProductId)) {
          console.error('Invalid orderProductId for existing product unit assignment');
          return;
        }
        assignUnits(orderId, orderProductId, units)
          .then(() => {
            refresh?.();
            toast('Units assigned successfully');
          })
          .catch(() => {
            toast('Error assigning units', 'error');
          });
      }
    },
    [isNewProduct, updateInputItem, orderId, id, refresh],
  );

  return {
    updateUnits,
  };
};
